<template>
  <div class="page-wrapper">
    <div class="box">
      <div class="top">
        <div class="container">
          <div class="row">
            <div class="col-12 text-left" style="height:50px;">
              <span class="pay-method" v-bind:class="{'mode-selected':currentMode == 0}" v-on:click="changeMode(0)">매장판매</span>
              <span class="pay-method" v-bind:class="{'mode-selected':currentMode == 1}" v-on:click="changeMode(1)">온라인판매</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="container-fluid h-100">
          <div class="row h-100">
            <div class="col-8 h-100 scroll-container">
              <table class="table">
                <tr>
                  <th>Goods</th>
                  <th>Unit Price</th>
                  <th>Amount</th>
                  <th>Total Price</th>
                  <th>TAX</th>
                  <th></th>
                </tr>
                <tbody v-if="orderList.length > 0">
                  <tr v-for="(item, index) in orderList">
                    <td>N {{item.title}}</td>
                    <td>{{getMoney(item.price)}}</td>
                    <td>{{item.amount}}</td>
                    <td>{{getMoney(item.totalPrice)}}</td>
                    <td>{{getMoney(item.tax)}}</td>
                    <td><span v-on:click="removeOrderItem(index)"><i class="fa fa-trash"></i>취소</span></td>
                  </tr>
                </tbody>
                <tbody v-if="stockList.length > 0">
                  <tr v-for="(stock, index) in stockList">
                    <td>S {{stock.title}} #{{stock.id}}</td>
                    <td>{{getMoney(stock.salesGross)}}</td>
                    <td>{{stock.changeBalance}}</td>
                    <td>{{getMoney(stock.salesGross)}}</td>
                    <td>{{getMoney(stock.salesVat)}}</td>
                    <td><span v-on:click="removeOrderStockItem(index)"><i class="fa fa-trash"></i>취소</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-4 h-100 scroll-container">
              <table class="table">
                <tbody v-if="orderItem != false">
                  <tr>
                    <td>Number of Items</td>
                    <td>{{orderList.length + stockList.length}}</td>
                  </tr>
                  <tr>
                    <td>TAX</td>
                    <td>{{getMoney(orderItem.tax)}}</td>
                  </tr>
                  <tr>
                    <td>TOTAL</td>
                    <td>{{getMoney(orderItem.totalPrice)}}</td>
                  </tr>
                </tbody>



              </table>
              <div class="container">
                <div class="row">
                  <div class="col-12 text-right" v-if="orderItem != false">

                    <span class="pay-method" v-on:click="acceptPaymentCash"><i class="fa fa-money"></i> CASH</span>
                    <span class="pay-method" v-on:click="acceptPaymentCard"><i class="fa fa-credit-card"></i> CARD</span>
                    <span class="pay-method" v-on:click="cancelShopSales"><i class="fa fa-cancel"></i> CANCEL</span>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="receipt-container" v-if="showReceipt == true">
      <div class="receipt-inner-container">
        <div class="scroll-container">
          <div class="container" id="sales-receipt">
            <div class="row">
              <div class="col-6">
                <h1>MACE</h1>
                <p>1st Floor, Mace House<br>
                  39-41 High Street<br>
                  New Malden<br> KT3 4BY </p>
              </div>
              <div class="col-6 text-right">
                <img src="/static/mace_logo.png" height="100px;"/>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <table class="table">
                  <tr>
                    <th>Goods</th>
                    <th class="text-right">Unit Price</th>
                    <th class="text-right">Amount</th>
                    <th class="text-right">TAX</th>
                    <th class="text-right">Total Price</th>
                  </tr>
                  <tbody v-if="orderList.length > 0">
                    <tr v-for="(item, index) in orderList">
                      <td>{{item.title}}</td>
                      <td class="text-right">{{getMoney(item.price)}}</td>
                      <td class="text-right">{{item.amount}}</td>
                      <td class="text-right">{{getMoney(item.tax)}}</td>
                      <td class="text-right">{{getMoney(item.totalPrice)}}</td>
                    </tr>
                  </tbody>
                  <tbody v-if="stockList.length > 0">
                    <tr v-for="(item, index) in stockList">
                      <td>{{item.title}}</td>
                      <td class="text-right">{{getMoney(item.salesGross)}}</td>
                      <td class="text-right">{{item.changeBalance}}</td>
                      <td class="text-right">{{getMoney(item.salesVat)}}</td>
                      <td class="text-right">{{getMoney(item.salesGross)}}</td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th class="text-right">VAT</th>
                      <th class="text-right">{{getMoney(orderItem.tax)}}</th>

                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th class="text-right">TOTAL</th>
                      <th class="text-right">{{getMoney(orderItem.totalPrice)}}</th>

                    </tr>
                  </tbody>
                </table>

              </div>
            </div>

            <footer class="fixed-bottom">
              <div class="container">
                <div class="row">
                  <div class="col-12">
                    Joe & Juliet (uk) Ltd.<br>VAT No: 1234567890
                  </div>
                </div>
              </div>

            </footer>
          </div>
        </div>

        <div class="container fixed-bottom">
          <div class="row">
            <div class="col-6">
              <span v-on:click="printReceipt"><i class="fa fa-print"></i>PRINT</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog width="500"/>

  </div>
</template>

<script>
    import {getProductWithBarcode, getProductStock, updateProductItem, addStock} from '../api/product';
    import {updateOrder} from '../api/order'
    import {millisToDate, millisToReadable} from '../api/utils'
    export default {
        name: "Pos",
        data() {
            return {
                currentMode:0,
                isLoading:false,
                inputList:[],
                scannerTime:0,
                orderList:[],
                stockList:[],
                orderItem:false,
                receiptItem:false,
                showReceipt: false,
            }
        },
        created() {
        },
        mounted() {
            window.addEventListener('keydown', this.keyHandler);
        },
        beforeDestroy() {
            window.removeEventListener('keydown', this.keyHandler);
        },
        computed:{

        },
        methods: {
            keyHandler: function(event) {
                let key = event.key;
                if(this.$data.scannerTimer) {
                    console.log("Renew timer");
                    clearTimeout(this.$data.scannerTimer);
                }

                if(key == 'Enter') {
                    console.log("Enter key : clear timer")
                    clearTimeout(this.$data.scannerTimer);
                    console.log("Enter key : check type")
                    if(this.$data.inputList.length == 13) {
                        console.log(this.$data.inputList.join(''));
                    } else if(this.$data.inputList.length == 24) {
                        console.log(this.$data.inputList.join(''));
                    } else {
                        console.log("Nothing " + this.$data.inputList.length);
                    }
                    this.$data.barCode = this.$data.inputList.join('');

                    this.$data.inputList = [];
                    this.onBarcodeEntered();
                    return;
                }
                this.$data.inputList.push(key);

                let self = this;
                this.$data.scannerTimer = setTimeout(function(){
                    console.log("Timed out so clear timer");
                    self.$data.inputList = [];
                    clearTimeout(self.$data.scannerTimer);
                }, 500);
            },
            showModal: function(title, message) {
                console.log("show modal " + title  + " : " + message);
                this.$modal.show('dialog',{
                    title: title,
                    text: message,
                    buttons:[
                        {title:'Close'}
                    ]
                })
                return;
            },
            getMoney: function(val) {
                return (parseFloat(val)/100).toFixed(2);
            },
            // Get Product with barcode
            onBarcodeEntered: function() {
                let self = this;
                this.$data.productItem = false;
                //this.$data.stockList = [];
                getProductWithBarcode(this.$data.barCode)
                    .then(function(data){
                        console.log(data);
                        if(data.success === true) {
                            if(data.item != null && data.item != undefined) {
                                self.addOrderItem(data.item);
                            }

                        } else {
                            self.showModal("Sorry", data.message);
                        }
                    })
                    .catch(function(err){
                        console.log(err);
                        console.log(err.response);
                        self.showModal("ERROR", err);
                    })
            },
            changeMode: function(newMode) {
                this.$data.currentMode = newMode;
                this.$data.orderItem = false;
                this.$data.orderList = [];
            },
            addOrderStockItem: function(product) {
                if(product.state > 0) {
                    this.showModal("ERROR", "이미 판매된 항목입니다");
                    return;
                }



                if(this.$data.orderItem == false) {
                    this.$data.orderItem = {
                        id:0,
                        parentId:0,
                        type:'shop_sales',
                        totalPrice:0,
                        tax:0,
                    }
                }




            },
            addOrderItem: function(product) {
                if(this.$data.orderItem == false) {
                    this.$data.orderItem = {
                        id:0,
                        parentId:0,
                        type:'shop_sales',
                        totalPrice:0,
                        tax:0,
                    }
                }
                if(product.stockItem != null && product.stockItem != undefined) {

                    for(let i = 0; i < this.$data.stockList.length ; i++) {
                        if(this.$data.stockList[i].id == product.stockItem.id) {
                            this.showModal("ERROR", "이미 리스트에 있습니다");
                            return;
                        }
                    }
                    let stockItem = JSON.parse(JSON.stringify(product.stockItem));
                    if(stockItem.state > 0) {
                        this.showModal("ERROR", "이미 판매된 항목입니다");
                        return;
                    }
                    stockItem.title = product.title;
                    if(stockItem.colour != undefined && stockItem.colour != null && stockItem.colour.length > 0)
                        stockItem.title += ' ' + stockItem.colour;
                    stockItem.state = 10;
                    stockItem.type = 'stock_out';
                    stockItem.changeType = 'shop_sales';
                    stockItem.salesGross = product.price;
                    stockItem.salesVat = stockItem.salesGross/6;
                    stockItem.salesNet = stockItem.salesGross - stockItem.salesVat;

                    stockItem.salesTime = new Date().getTime();
                    //stockItem.salesTime = today.getTime();

                    this.$data.stockList.push(stockItem);
                    this.updateOrderSummary();
                    console.log("Order Added");
                    console.log(this.$data.stockList);
                    return;
                }
                if(product.stockBalance > 0) {
                    let item = {
                        id:0,
                        parentId:this.$data.orderItem.id,
                        title:product.title,
                        productId:product.id,
                        amount:1,
                        price:product.price,
                        tax: product.tax / (10000 + product.tax) * product.price,
                        totalPrice:product.price,
                        type:'shop_sales',
                    };
                    this.$data.orderList.push(item);
                } else {
                    this.showModal("No stock", "This product does not have any stock");
                }
                this.updateOrderSummary();
            },
            removeOrderItem: function(index) {
               this.$data.orderList.splice(index, 1);
               this.updateOrderSummary();
            },
            removeOrderStockItem: function(index) {
                this.$data.stockList.splice(index, 1);
                this.updateOrderSummary();
            },
            updateOrderSummary: function() {
                if(this.$data.orderItem == false) {
                    return;
                }

                this.$data.orderItem.totalPrice = 0;
                this.$data.orderItem.tax = 0;

                console.log("Order Summary");
                console.log(this.$data.orderList);
                for(let i = 0 ; i < this.$data.orderList.length ; i++) {
                    this.$data.orderItem.totalPrice += this.$data.orderList[i].totalPrice;
                    this.$data.orderItem.tax += parseInt(this.$data.orderList[i].tax);
                }
                for(let i = 0 ; i < this.$data.stockList.length ; i++) {
                    this.$data.orderItem.totalPrice += this.$data.stockList[i].salesGross;
                    this.$data.orderItem.tax += parseInt(this.$data.stockList[i].salesVat);
                }
            },
            acceptPaymentCash: function() {
                this.$data.orderItem.cashPayment = this.$data.orderItem.totalPrice;
                this.completeSale();
            },
            acceptPaymentCard: function() {
                this.$data.orderItem.cardPayment = this.$data.orderItem.totalPrice;
                this.completeSale();
            },
            completeSale: function() {
                this.$data.orderItem.list = this.$data.orderList;
                this.$data.orderItem.stockList = this.$data.stockList;
                let self = this;
                self.$data.showReceipt = true;
                updateOrder(this.$data.orderItem)
                    .then(function(data){
                        console.log("completed Sale response");
                        console.log(data);
                        if(data.success == true) {
                            // self.$data.orderItem = false;
                            // self.$data.orderList = [];

                            setInterval(self.printReceipt(), 500);
                        } else {
                            console.log("Error " + data.message);
                            self.showModal("Error", data.message);
                        }
                    })
                    .catch(function(err){
                        console.log(err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            printReceipt: function(){

                let self = this;
                this.$htmlToPaper('sales-receipt', ()=>{
                    console.log("Printing completed or was cancelled");
                    self.$data.showReceipt = false;
                    self.$data.orderItem = false;
                    self.$data.orderList = [];
                    self.$data.stockList = [];
                });
            },
            cancelShopSales: function() {
                this.$data.showReceipt = false;
                this.$data.orderItem = false;
                this.$data.orderList = [];
                this.$data.stockList = [];
            }
        }
    }
</script>

<style lang="css" scoped>
  .page-wrapper {
    display: flex;
    flex-flow: column;
    height: 100%;
  }
  .box {
    width:100%;
    height: 100%;
    display: flex;
    flex-flow: column;
  }
  .top {
    flex: 0 1 auto;
  }
  .content {
    flex: 1 1 auto;
  }
  .pay-method {
    border:1px solid black;
    border-radius: 2px;
    padding:10px;
    margin-right: 5px;
    cursor: pointer;
  }


  .receipt-container {
    position: fixed;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.3);
  }
  .receipt-inner-container {
    position: relative;
    width: 50%;
    min-width: 500px;
    height: 80%;
    top:50%;
    left: 50%;
    transform:translate(-50%, -50%);
    background: white;
  }
  .align-td {
    padding: .75rem;
  }

  .mode-selected {
    background: blue;
    color:white;
  }
  #sales-receipt {
    background-image: url("/mace_logo.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 300px 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pos.vue